import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { WelcomeComponent } from "./core/welcome/welcome.component";
import { AdminPanelComponent } from "./core/admin-panel/admin-panel.component";
import { AdminPanelCsvComponent } from "./core/admin-panel/admin-panel-csv/admin-panel-csv.component";
import { AdminUsersComponent } from "./core/admin-users/admin-users.component";
import { AddUserComponent } from "./core/admin-users/admin-add-user/addUser.component";
import { AuthGuard } from "./shared/guards/auth.guard";
import { RoleEnum } from "./shared/Models/enums/RoleEnum";
import { AnnotationRoutingModule } from "./annotation/annotation-routing.module";
import { FailedCommandComponent } from "./core/failed-command/components/failed-command/failed-command.component";
import { SurveyOchestratorComponent } from "./core/survey/survey-ochestrator/survey-ochestrator.component";
import { BuildingTableComponent } from "./core/building-list/components/building-table/building-table.component";
import { DocumentListComponent } from "./core/document-list/components/document-list.component";
import { AdminPanelTriggerInitialLoadComponent } from "./core/admin-panel/admin-panel-trigger-initial-load/admin-panel-trigger-initial-load.component";
import { AdminPanelVerifyMftComponent } from "./core/admin-panel/admin-panel-verify-mft/admin-panel-verify-mft.component";
import { UnsavedChangesGuard } from "./shared/guards/unsaved-changes.guard";
import { BuildingSearchComponent } from "./core/building-search/component/building-search.component";
import { AdminPanelFiberHoodContactsComponent } from "./core/admin-panel/admin-panel-fiber-hood-contacts/admin-panel-fiber-hood-contacts.component";
import { AdminPanelCsvExportFieldsComponent } from "./core/admin-panel/admin-panel-csv-export-fields/admin-panel-csv-export-fields.component";
import { FailedCommandDetailsComponent } from "./core/failed-command/components/failed-command-details/failed-command-details.component";
import { AdminPanelBulkConfigurationComponent } from "./core/admin-panel/admin-panel-bulk-configuration/admin-panel-bulk-configuration.component";
import { AdminPanelBulkComponent } from "./core/admin-panel/admin-panel-bulk/admin-panel-bulk.component";
import { AdminPanelBulkUploadDialogComponent } from "./core/admin-panel/admin-panel-bulk/admin-panel-bulk-upload-dialog/admin-panel-bulk-upload-dialog.component";
import { ImportBuildingsComponent } from "./core/admin-panel/import-buildings/import-buildings.component";
import { TemplatesOverviewComponent } from "./core/admin-panel/templates-overview/templates-overview.component";
import { CreateTemplateComponent } from "./core/admin-panel/templates-overview/create-template/create-template.component";
import { EmptyBuildingListComponent } from "./core/building-list/components/empty-building-list/empty-building-list.component";
import { AdminPanelSettingsComponent } from "./core/admin-panel/admin-panel-settings/admin-panel-settings.component";
import { BrowserUtils } from "@azure/msal-browser";
import { AdminPanelMaintenanceMessagesComponent } from "./core/admin-panel/admin-panel-maintenancemessages/admin-panel-maintenancemessages.component"



const routes: Routes = [
  {
    path: "welcome",
    component: WelcomeComponent,
    canActivate: [AuthGuard],
    data: { roles: [RoleEnum.Admin] },
  },
  {
    path: "admin",
    component: AdminPanelComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        RoleEnum.Admin,
        RoleEnum.Manager,
        RoleEnum.Planner,
        RoleEnum.Surveyor,
        RoleEnum.Validator,
        RoleEnum.Viewer,
        RoleEnum.OperationAdmin,
      ],
    },
  },
  {
    path: "admin/csv",
    component: AdminPanelCsvComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        RoleEnum.Admin,
        RoleEnum.Manager,
        RoleEnum.Planner,
        RoleEnum.Surveyor,
        RoleEnum.Validator,
        RoleEnum.Viewer,
      ],
    },
  },
  {
    path: "admin/admin-panel-csv-export-fields",
    component: AdminPanelCsvExportFieldsComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [RoleEnum.Admin],
    },
  },
  {
    path: "admin/admin-panel-bulk-configuration",
    component: AdminPanelBulkConfigurationComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [RoleEnum.OperationAdmin],
    },
  },
  {
    path: "admin/admin-panel-bulk-upload-dialog",
    component: AdminPanelBulkUploadDialogComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [RoleEnum.OperationAdmin, RoleEnum.Admin],
    },
  },
  {
    path: "admin/admin-panel-bulk",
    component: AdminPanelBulkComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [RoleEnum.OperationAdmin, RoleEnum.Admin],
    },
  },
  {
    path: "admin/commands",
    component: FailedCommandComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        RoleEnum.Admin,
        RoleEnum.Manager,
        RoleEnum.Planner,
        RoleEnum.Surveyor,
        RoleEnum.Validator,
        RoleEnum.Viewer,
        RoleEnum.OperationAdmin,
      ],
    },
  },
  {
    path: "admin/commands/:id",
    component: FailedCommandDetailsComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        RoleEnum.Admin,
        RoleEnum.Manager,
        RoleEnum.Planner,
        RoleEnum.Surveyor,
        RoleEnum.Validator,
        RoleEnum.Viewer,
        RoleEnum.OperationAdmin,
      ],
    },
  },
  {
    path: "admin/user",
    component: AdminUsersComponent,
    canActivate: [AuthGuard],
    data: { roles: [RoleEnum.Admin, RoleEnum.OperationAdmin] },
    children: [
      {
        path: "add",
        component: AddUserComponent,
        canActivate: [AuthGuard],
        data: { roles: [RoleEnum.Admin, RoleEnum.OperationAdmin] },
      },
    ],
  },
  {
    path: "admin/fiber-hood-contacts",
    component: AdminPanelFiberHoodContactsComponent,
    canActivate: [AuthGuard],
    data: { roles: [RoleEnum.Admin] },
  },
  {
    path: "admin/templates",
    component: TemplatesOverviewComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        RoleEnum.Admin,
        RoleEnum.Manager,
        RoleEnum.Planner,
        RoleEnum.Surveyor,
        RoleEnum.Validator,
        RoleEnum.Viewer,
      ],
    },
  },
  {
    path: "admin/templates/create",
    component: CreateTemplateComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [RoleEnum.Admin, RoleEnum.OperationAdmin],
    },
  },
  {
    path: "admin/initial-load",
    component: AdminPanelTriggerInitialLoadComponent,
    canActivate: [AuthGuard],
    data: { roles: [RoleEnum.Admin] },
  },
  {
    path: "admin/verify-mft",
    component: AdminPanelVerifyMftComponent,
    canActivate: [AuthGuard],
    data: { roles: [RoleEnum.Admin] },
  },
  {
    path: "admin/import-buildings",
    component: ImportBuildingsComponent,
    canActivate: [AuthGuard],
    data: { roles: [RoleEnum.OperationAdmin] },
  },
  {
    path: "admin/settings",
    component: AdminPanelSettingsComponent,
    canActivate: [AuthGuard],
    data: { roles: [RoleEnum.OperationAdmin, RoleEnum.Admin] },
  },
  {
    path: "admin/maintenancemessages",
    component: AdminPanelMaintenanceMessagesComponent,
    canActivate: [AuthGuard],
    data: { roles: [RoleEnum.OperationAdmin] },
  },
  {
    path: "building-table",
    component: BuildingTableComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        RoleEnum.Admin,
        RoleEnum.Planner,
        RoleEnum.Surveyor,
        RoleEnum.Validator,
        RoleEnum.Manager,
        RoleEnum.Viewer,
        RoleEnum.OperationAdmin,
      ],
    },
  },
  {
    path: "building-table/empty-buildings",
    component: EmptyBuildingListComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [RoleEnum.OperationAdmin],
    },
  },
  {
    path: "survey/:surveyStatus/:id/:isPrefill",
    component: SurveyOchestratorComponent,
    canActivate: [AuthGuard],
    canDeactivate: [UnsavedChangesGuard],
    data: {
      roles: [
        RoleEnum.Admin,
        RoleEnum.Surveyor,
        RoleEnum.Validator,
        RoleEnum.Manager,
        RoleEnum.Viewer,
        RoleEnum.Planner,
        RoleEnum.OperationAdmin,
      ],
    },
  },
  {
    path: "documents",
    component: DocumentListComponent,
  },
  {
    path: "search",
    component: BuildingSearchComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      relativeLinkResolution: "legacy",
      initialNavigation:
        !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup()
          ? "enabledNonBlocking"
          : "disabled",
    }),
    AnnotationRoutingModule,
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
